(function () {
  if (customElements.get('image-carousel-block')) return;

  class ImageCarouselBlock extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevButton = null;
      this.nextButton = null;
      this.dotsContainer = null;
      this.currentIndex = 0;
      this.slidesPerView = 4;
      this.totalSlides = 0;
      this._onResize = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.dotsContainer = this.querySelector('[data-carousel-dots]');
      this.totalSlides = this.track ? this.track.children.length : 0;

      this.updateSlidesPerView();
      this.setupEventListeners();
      this.createDots();
      this.updateControls();
      this.setupTouchEvents();
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }
    }

    updateSlidesPerView() {
      this.slidesPerView = window.innerWidth <= 749 ? 2 : 4;
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      this._onResize = () => {
        const previousSlidesPerView = this.slidesPerView;
        this.updateSlidesPerView();

        if (previousSlidesPerView !== this.slidesPerView) {
          this.currentIndex = Math.min(
            this.currentIndex,
            Math.max(0, this.totalSlides - this.slidesPerView)
          );
          this.createDots();
        }

        this.updateControls();
      };

      window.addEventListener('resize', this._onResize);
    }

    setupTouchEvents() {
      if (!this.track) return;

      let startX = 0;
      let scrollLeft = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX;
        scrollLeft = this.track.scrollLeft;
      });

      this.track.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        this.track.scrollLeft = scrollLeft + walk;
      });

      this.track.addEventListener('touchend', () => {
        this.snapToSlide();
      });

      this.track.addEventListener('mousedown', (e) => {
        startX = e.pageX;
        scrollLeft = this.track.scrollLeft;
        this.track.style.cursor = 'grabbing';
      });

      this.track.addEventListener('mousemove', (e) => {
        if (e.buttons !== 1) return;
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        this.track.scrollLeft = scrollLeft + walk;
      });

      this.track.addEventListener('mouseup', () => {
        this.track.style.cursor = 'grab';
        this.snapToSlide();
      });

      this.track.addEventListener('mouseleave', () => {
        this.track.style.cursor = 'grab';
      });
    }

    snapToSlide() {
      if (!this.track || this.totalSlides === 0) return;

      const slideWidth = this.track.scrollWidth / this.totalSlides;
      const newIndex = Math.round(this.track.scrollLeft / slideWidth);
      this.currentIndex = Math.max(0, Math.min(newIndex, this.totalSlides - this.slidesPerView));
      this.scrollToIndex(this.currentIndex);
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      const maxDots = this.totalSlides - this.slidesPerView + 1;

      for (let i = 0; i < maxDots; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'image-carousel__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.scrollToIndex(i);
        });
        this.dotsContainer.appendChild(dot);
      }

      this.updateDots();
    }

    updateDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.querySelectorAll('.image-carousel__dot').forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    }

    scrollToIndex(index) {
      if (!this.track || this.totalSlides === 0) return;

      const slideWidth = this.track.scrollWidth / this.totalSlides;
      this.track.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
      this.updateControls();
      this.updateDots();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.scrollToIndex(this.currentIndex);
      }
    }

    next() {
      if (this.currentIndex < this.totalSlides - this.slidesPerView) {
        this.currentIndex++;
        this.scrollToIndex(this.currentIndex);
      }
    }

    updateControls() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.totalSlides - this.slidesPerView;
      }
    }
  }

  customElements.define('image-carousel-block', ImageCarouselBlock);
})();
